module.exports = {"330402007":"建设街道","330402008":"解放街道","330402009":"新嘉街道","330402010":"南湖街道","330402011":"新兴街道","330402012":"城南街道","330402013":"东栅街道","330402014":"长水街道","330402015":"七星街道","330402100":"凤桥镇","330402101":"余新镇","330402103":"新丰镇","330402105":"大桥镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330402.json
// module id = 979
// module chunks = 0